<script lang="ts" setup>
import { useCheckoutStore } from '@entities/order'
import { LoaderFullScreenDomain } from '@shared/ui/loaders'

defineOptions({
  name: 'LayoutCheckout',
})

const checkoutStore = useCheckoutStore()
</script>

<template>
  <div class="cs-order">
    <slot
      v-if="checkoutStore.isOrderId"
    />
    <!-- TODO(INFRA-724): error block with retry; a failed order fetch shows the loader until then -->
    <LoaderFullScreenDomain v-else />
  </div>
</template>

<style scoped lang="scss" src="@app/layouts/order.scss" />
